import {
  APPLICATION_FLOW_STATUS,
  ApplicationFlowAttributes,
  SubmitApplicationFlowRequestData,
} from 'typescript/types/api/capital_shop/application_flows';

export const applicationFullName = (
  applicationFlowAttributes?: ApplicationFlowAttributes,
): string => {
  if (!applicationFlowAttributes) return '';

  return `${applicationFlowAttributes.personal_first_name} ${applicationFlowAttributes.personal_last_name}`;
};

export const buildSubmitApplicationFlowRequestData = (
  personal_ssn: string,
  personal_birthdate: string,
  applicationFlowAttributes: ApplicationFlowAttributes,
): SubmitApplicationFlowRequestData => {
  return {
    personal_first_name: applicationFlowAttributes.personal_first_name,
    personal_last_name: applicationFlowAttributes.personal_last_name,
    personal_street_1: applicationFlowAttributes.personal_street_1,
    personal_street_2: applicationFlowAttributes.personal_street_2,
    personal_city: applicationFlowAttributes.personal_city,
    personal_state_province: applicationFlowAttributes.personal_state_province,
    personal_postal_code: applicationFlowAttributes.personal_postal_code,
    accepted_legal_agreements: true,
    personal_birthdate,
    personal_ssn,
  };
};

export const applicationReviewed = (
  applicationFlowAttributes?: ApplicationFlowAttributes,
): boolean => {
  return applicationFlowAttributes?.status === APPLICATION_FLOW_STATUS.REVIEWED;
};
